/**
 * Content-Dispositionヘッダーよりファイル名を取得して返します
 * @param disposition ファイルの情報を含むContent-Dispositionヘッダー
 * @param def dispositonが取得できなかった場合などのファイル名
 * @returns
 */
export const getFileNameFromContentDisposition = (disposition: string, def: string): string => {
  console.log(disposition);
  if (!disposition) return def;
  const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
  const matches = filenameRegex.exec(disposition);
  if (matches != null && matches[1]) {
    const fileName = matches[1].replace(/['"]/g, "");
    return decodeURI(fileName); // 日本語対応
  } else {
    return def;
  }
};
